<div class="images">
    @for (url of galleryUrls.slice(0, 2); track url) {
        @if (url) { <tec-file-preview [fileUrl]="url" [sizeSm]="true" (click)="showViewMedia(url)" /> }
    }
</div>

<tec-divider />

<div class="item-group">
    <span>{{ 'OPERATIONS.DETAIL.TABS.DETAILS.CAPTURES_TITLE' | translate | uppercase }}</span>
    <div class="images">
        @for (url of galleryUrls.slice(0, 4); track url) {
            @if (url) { <tec-file-preview [fileUrl]="url" [sizeSm]="true" (click)="showViewMedia(url)" /> }
        }
    </div>
</div>

<div class="buttons">
    <tec-button [label]="'OPERATIONS.DETAIL.TABS.DETAILS.EXPLORE_GALLERY' | translate" (click)="openGallery()" />
    <tec-link [label]="'BUTTON.DOWNLOAD' | translate" (click)="downloadMedia()">
        <tec-icon name="icon-download" size="sm" />
    </tec-link>
</div>
